import { UserEnrichment } from '@nx-frontend/shared/types';

export function getUserName(user: UserEnrichment | null | undefined): string | undefined | null {
  if (!user) return null;
  const name: string[] = [];
  if (user.firstname) {
    name.push(user.firstname);
  }
  if (user.lastname) {
    name.push(user.lastname);
  }
  if (name.length) {
    return name.join(' ');
  }
  return user.email;
}
